import React from "react";
// import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FileUpload from "react-dropzone";

// @material-ui/icons
import FileIcon from "@material-ui/icons/CloudUpload";

import ManifestFileTemplate from "./ManifestFileTemplate.xls";

import {
  Grid,
  // Input,
  // MenuItem,
  FormControl,
  InputLabel
  // Select
} from "@material-ui/core";

import Button from "components/CustomButtons/Button.jsx";
import InlineDatePicker from "../../utils/InlineDatePicker";
import { appConstants } from "../../_constants";
import AutocompleteSelect from "./../../utils/AutocompleteSelect";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  input: {
    marginTop: "0 !important"
  },
  nb: {
    color: "red",
    fontSize: "12px"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: "67%"
  },
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    width: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  },
  searchButton: {
    backgroundColor: " #66bb6a"
  },
  airlineSelect: {
    marginTop: "0px",
    width: "100%"
  },
  fileUploadStyle: {
    width: "100%",
    paddingTop: "20px",
    paddingBottom: "20px",
    border: "1px dashed #aaa",
    borderRadius: "10px",
    cursor: "pointer"
  },
  fileIconStyle: {
    fontSize: "50px",
    color: "#4caf50"
  },
  fileDescStyle: {
    margin: 0,
    textTransform: "none"
  },
  bold: {
    fontWeight: "bold"
  },
  colorMute: {
    color: "rgba(0, 0, 0, 0.4)"
  }
});

// const fileUploadStyle = {
//     width: "100%",
//     paddingTop: "20px",
//     paddingBottom: "20px",
//     border: "1px dashed #aaa",
//     borderRadius: "10px",
//     cursor: 'pointer'
// };

function AddRecordModal(props) {
  const {
    classes,
    data,
    flightNumbers,
    selectChange,
    handleDateChange,
    handleOpenModal,
    handleClose,
    handleSubmit,
    isOpen,
    error,
    formError,
    requesting,
    airlineError,
    flightError,
    locationData,
    locationError,
    destinationData,
    destinationError,
    billablePaxError,
    passengerCountError,
    flightDate,
    billablePaxError2,
    selectReactSelectChange,
    user,
    locationId,
    fileName,
    onDrop
  } = props;

  return (
    <div className={classes.root}>
      <Grid container spacing={24}>
        <Grid item md={12} xs={12}>
          <Button
            style={{
              float: "right",
              marginBottom: "30px"
            }}
            color={"primary"}
            onClick={handleOpenModal}
          >
            Add Record
          </Button>
        </Grid>
      </Grid>

      {/* Add DataEntry Modal */}
      <Dialog
        // fullScreen={fullScreen}
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          id="responsive-dialog-title"
          style={{ backgroundColor: "#66bb6a" }}
        >
          <span style={{ color: "white", textTransform: "uppercase" }}>
            {" "}
            Add Record
          </span>
        </DialogTitle>
        <DialogContent style={{ marginTop: "20px" }}>
          <Grid container spacing={24}>
            <Grid item md={12} xs={12}>
              {error && <span style={{ color: "red" }}>{formError}</span>}

              <FormControl
                className={classNames(
                  classes.airlineSelect,
                  classes.formControl
                )}
              >
                <InputLabel shrink htmlFor="airlineId">
                  Airline Name
                </InputLabel>
                <AutocompleteSelect
                  options={data.map(option => ({
                    value: option.AirlineId,
                    label: option.Airline
                  }))}
                  // selectedOption={selectedAirline}
                  handleSelectChange={(e, name) =>
                    selectReactSelectChange(e, name)
                  }
                  // selectLabel={"Airlines"}
                  name={"addAirlineId"}
                />
                {/*<Select*/}
                {/*value={addAirlineId}*/}
                {/*onChange={selectChange}*/}
                {/*// inputProps={{*/}
                {/*//   name: 'airlineId',*/}
                {/*//   id: 'airline',*/}
                {/*// }}*/}
                {/*name="addAirlineId"*/}
                {/*input={<Input name="airline" id="airline-label-placeholder" />}*/}
                {/*>*/}
                {/*<MenuItem value="-1">Select Airline</MenuItem>*/}
                {/*{data.map((option, i) => (*/}
                {/*<MenuItem*/}
                {/*key={i}*/}
                {/*value={option.AirlineId}*/}
                {/*className={classes.select}*/}
                {/*>*/}
                {/*{option.Airline}*/}
                {/*</MenuItem>*/}
                {/*))}*/}
                {/*</Select>*/}
              </FormControl>
              {airlineError && (
                <span style={{ color: "red" }}>
                  {"Valid Airline is required"}
                </span>
              )}
            </Grid>
            <Grid item md={12} xs={12}>
              <FormControl
                className={classNames(
                  classes.airlineSelect,
                  classes.formControl
                )}
              >
                <InputLabel shrink htmlFor="age-label-placeholder">
                  Flight Number
                </InputLabel>
                <AutocompleteSelect
                  options={flightNumbers.map(option => ({
                    value: option.FlightNumber,
                    label: option.FlightNumber
                  }))}
                  name={"FlightNumber"}
                  handleSelectChange={(e, name) =>
                    selectReactSelectChange(e, name)
                  }
                />
                {/*<Select*/}
                {/*value={FlightNumber}*/}
                {/*onChange={selectChange}*/}
                {/*input={<Input name="Flight No" id="airline-label-placeholder" />}*/}
                {/*// displayEmpty*/}
                {/*name="FlightNumber"*/}
                {/*className={classes.flightNumber}*/}
                {/*>*/}
                {/*<MenuItem value="-1"> All Flights</MenuItem>*/}
                {/*{flightNumbers.map((option, i) => (*/}
                {/*<MenuItem*/}
                {/*key={i}*/}
                {/*value={option.FlightNumber}*/}
                {/*className={classes.flightNumber}*/}
                {/*>*/}
                {/*{option.FlightNumber}*/}
                {/*</MenuItem>*/}
                {/*))}*/}
                {/*</Select>*/}
              </FormControl>
              {flightError && (
                <span style={{ color: "red" }}>
                  {"Valid Flight Number is required"}
                </span>
              )}
            </Grid>
            <Grid item md={12} xs={12}>
              <div
                className={classNames(
                  classes.airlineSelect,
                  classes.formControl
                )}
              >
                <FormControl
                  className={classNames(
                    classes.airlineSelect,
                    classes.formControl
                  )}
                >
                  <InlineDatePicker
                    Date={flightDate}
                    // handleDateChange={handleDateChange}
                    handleDateChange={date =>
                      handleDateChange(date, "flightDate")
                    }
                    label="Departure Date"
                  />
                </FormControl>
              </div>
            </Grid>
            <Grid item md={12} xs={12}>
              <FormControl
                className={classNames(
                  classes.airlineSelect,
                  classes.formControl
                )}
              >
                <InputLabel shrink htmlFor="airlineId">
                  Departure Location
                </InputLabel>
                <AutocompleteSelect
                  options={locationData.map(option => ({
                    value: option.Code,
                    label: option.Name
                  }))}
                  // selectedOption={selectedAirline}
                  handleSelectChange={(e, name) =>
                    selectReactSelectChange(e, name)
                  }
                  // selectLabel={"Airlines"}
                  name={"locationId"}
                  disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER}
                  selectedOption={locationId}
                />
                {/*<Select*/}
                {/*value={locationId}*/}
                {/*onChange={selectChange}*/}
                {/*disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER}*/}
                {/*name="locationId"*/}
                {/*input={<Input name="airline" id="airline-label-placeholder" />}*/}
                {/*>*/}
                {/*<MenuItem value="-1">Select Location</MenuItem>*/}
                {/*{locationData.map((option, i) => (*/}
                {/*<MenuItem*/}
                {/*key={i}*/}
                {/*value={option.Code}*/}
                {/*className={classes.select}*/}
                {/*>*/}
                {/*{option.Name}*/}
                {/*</MenuItem>*/}
                {/*))}*/}
                {/*</Select>*/}
              </FormControl>
              {locationError && (
                <span style={{ color: "red" }}>
                  {"Valid Departure Location is required"}
                </span>
              )}
            </Grid>
            <Grid item md={12} xs={12}>
              <FormControl
                className={classNames(
                  classes.airlineSelect,
                  classes.formControl
                )}
              >
                <InputLabel shrink htmlFor="airlineId">
                  Destination
                </InputLabel>
                <AutocompleteSelect
                  options={destinationData.map(option => ({
                    value: option.Code,
                    label: option.Name
                  }))}
                  // selectedOption={selectedAirline}
                  handleSelectChange={(e, name) =>
                    selectReactSelectChange(e, name)
                  }
                  // selectLabel={"Airlines"}
                  name={"destinationId"}
                />
                {/*<Select*/}
                {/*value={destinationId}*/}
                {/*onChange={selectChange}*/}
                {/*name="destinationId"*/}
                {/*input={<Input name="airline" id="airline-label-placeholder" />}*/}
                {/*>*/}
                {/*<MenuItem value="-1">Destination</MenuItem>*/}
                {/*{destinationData.map((option, i) => (*/}
                {/*<MenuItem*/}
                {/*key={i}*/}
                {/*value={option.Code}*/}
                {/*className={classes.select}*/}
                {/*>*/}
                {/*{option.Name}*/}
                {/*</MenuItem>*/}
                {/*))}*/}
                {/*</Select>*/}
              </FormControl>
              {destinationError && (
                <span style={{ color: "red" }}>
                  {"Valid DestinationLocation is required"}
                </span>
              )}
            </Grid>
            <Grid item md={12} xs={12}>
              <CustomInput
                style={{ marginTop: "0px", marginBottom: "0px" }}
                className={classNames(classes.input)}
                required
                labelText="Passenger Count"
                id="passengerCount"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  name: "passengerCount",
                  type: "number",
                  onChange: selectChange
                }}
              />
              {passengerCountError && (
                <span style={{ color: "red" }}>
                  {"Valid Passenger Count is required"}
                </span>
              )}
            </Grid>
            <Grid item md={12} xs={12}>
              <CustomInput
                style={{ marginTop: "0px" }}
                className={classNames(classes.input)}
                required
                labelText="Billable Passenger Count"
                id="billablePaxCount"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  name: "billablePaxCount",
                  type: "number",
                  onChange: selectChange
                }}
              />
              {billablePaxError && (
                <span style={{ color: "red" }}>
                  {"Valid Billable Passenger Count is required"}
                </span>
              )}
              {billablePaxError2 && (
                <span style={{ color: "red" }}>
                  {"Billable Passenger cannot be greater than Passenger Count"}
                </span>
              )}
            </Grid>
            <Grid item md={12} xs={12}>
              <FileUpload
                onDrop={onDrop}
                className={classNames(classes.fileUploadStyle)}
              >
                <div className="text-center">
                  <FileIcon className={classNames(classes.fileIconStyle)} />
                  {!fileName && (
                    <div>
                      <h6
                        className={classNames(
                          classes.fileDescStyle,
                          classes.bold
                        )}
                      >
                        Drag & drop manifest file here
                      </h6>
                      <p className={classNames(classes.fileDescStyle)}>
                        or click to upload
                      </p>
                      <small className={classNames(classes.colorMute)}>
                        Only .xlsx files are accepted for upload.
                      </small>
                    </div>
                  )}
                  {fileName && (
                    <div>
                      <p>{fileName}</p>
                    </div>
                  )}
                </div>
              </FileUpload>
              <small>
                <a href={ManifestFileTemplate}>* Download manifest file template here</a>
              </small>
            </Grid>
            {/*<Grid item md={12} xs={12}>*/}
            {/*<CustomInput*/}
            {/*className={classes.input}*/}
            {/*required*/}
            {/*labelText="Comments"*/}
            {/*id="comment"*/}
            {/*formControlProps={{*/}
            {/*fullWidth: true*/}
            {/*}}*/}
            {/*inputProps={*/}
            {/*{*/}
            {/*name: "addComment",*/}
            {/*type: "text",*/}
            {/*value: addComment,*/}
            {/*onChange: selectChange,*/}
            {/*}}*/}
            {/*/>*/}
            {/*{error && <span style={{ color: 'red' }}>{formError}</span>}*/}
            {/*</Grid>*/}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="danger">
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={requesting}
            color="regional"
            autoFocus
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withStyles(styles)(AddRecordModal);



// WEBPACK FOOTER //
// ./src/views/DataEntry/AddRecordModal.js